import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationSportsAllianceData } from './Data';

export interface IntegrationSportsAllianceState extends BaseIntegrationState {
  fieldsMapped: number[];
  loginUrl?: string;
}

export class IntegrationSportsAllianceModel extends BaseIntegration<
  IntegrationSportsAllianceData,
  IntegrationSportsAllianceState
> {
  parse(data: IntegrationSportsAllianceData) {
    super.parse(data);

    this.state.fieldsMapped = data.settings?.sports_alliance_fields_mapped ?? [];
    this.state.loginUrl = data.settings?.sports_alliance_login_url;
  }

  authorSignature(): string {
    return 'Istvan Bovan';
  }

  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/custom/sports-alliance/View.vue');
  }

  hasVueComponent() {
    return true;
  }
}
